var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9857_122346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5H23C23.2652 5 23.5196 4.89464 23.7071 4.70711C23.8946 4.51957 24 4.26522 24 4C24 3.73478 23.8946 3.48043 23.7071 3.29289C23.5196 3.10536 23.2652 3 23 3H8.5C8.23478 3 7.98043 3.10536 7.79289 3.29289C7.60536 3.48043 7.5 3.73478 7.5 4C7.5 4.26522 7.60536 4.51957 7.79289 4.70711C7.98043 4.89464 8.23478 5 8.5 5Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 11H8.5C8.23478 11 7.98043 11.1054 7.79289 11.2929C7.60536 11.4804 7.5 11.7348 7.5 12C7.5 12.2652 7.60536 12.5196 7.79289 12.7071C7.98043 12.8946 8.23478 13 8.5 13H23C23.2652 13 23.5196 12.8946 23.7071 12.7071C23.8946 12.5196 24 12.2652 24 12C24 11.7348 23.8946 11.4804 23.7071 11.2929C23.5196 11.1054 23.2652 11 23 11Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19H8.5C8.23478 19 7.98043 19.1054 7.79289 19.2929C7.60536 19.4804 7.5 19.7348 7.5 20C7.5 20.2652 7.60536 20.5196 7.79289 20.7071C7.98043 20.8946 8.23478 21 8.5 21H23C23.2652 21 23.5196 20.8946 23.7071 20.7071C23.8946 20.5196 24 20.2652 24 20C24 19.7348 23.8946 19.4804 23.7071 19.2929C23.5196 19.1054 23.2652 19 23 19Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.49799H1.5C1.22386 2.49799 1 2.72184 1 2.99799V4.99799C1 5.27413 1.22386 5.49799 1.5 5.49799H3.5C3.77614 5.49799 4 5.27413 4 4.99799V2.99799C4 2.72184 3.77614 2.49799 3.5 2.49799Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.5H1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3L0 5C0 5.39782 0.158035 5.77936 0.43934 6.06066C0.720644 6.34196 1.10218 6.5 1.5 6.5H3.5C3.89782 6.5 4.27936 6.34196 4.56066 6.06066C4.84196 5.77936 5 5.39782 5 5V3C5 2.60218 4.84196 2.22064 4.56066 1.93934C4.27936 1.65804 3.89782 1.5 3.5 1.5ZM4 5C4 5.13261 3.94732 5.25979 3.85355 5.35355C3.75979 5.44732 3.63261 5.5 3.5 5.5H1.5C1.36739 5.5 1.24021 5.44732 1.14645 5.35355C1.05268 5.25979 1 5.13261 1 5V3C1 2.86739 1.05268 2.74021 1.14645 2.64645C1.24021 2.55268 1.36739 2.5 1.5 2.5H3.5C3.63261 2.5 3.75979 2.55268 3.85355 2.64645C3.94732 2.74021 4 2.86739 4 3V5Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.498H1.5C1.22386 10.498 1 10.7218 1 10.998V12.998C1 13.2741 1.22386 13.498 1.5 13.498H3.5C3.77614 13.498 4 13.2741 4 12.998V10.998C4 10.7218 3.77614 10.498 3.5 10.498Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.5H1.5C1.10218 9.5 0.720644 9.65804 0.43934 9.93934C0.158035 10.2206 0 10.6022 0 11L0 13C0 13.3978 0.158035 13.7794 0.43934 14.0607C0.720644 14.342 1.10218 14.5 1.5 14.5H3.5C3.89782 14.5 4.27936 14.342 4.56066 14.0607C4.84196 13.7794 5 13.3978 5 13V11C5 10.6022 4.84196 10.2206 4.56066 9.93934C4.27936 9.65804 3.89782 9.5 3.5 9.5ZM4 13C4 13.1326 3.94732 13.2598 3.85355 13.3536C3.75979 13.4473 3.63261 13.5 3.5 13.5H1.5C1.36739 13.5 1.24021 13.4473 1.14645 13.3536C1.05268 13.2598 1 13.1326 1 13V11C1 10.8674 1.05268 10.7402 1.14645 10.6464C1.24021 10.5527 1.36739 10.5 1.5 10.5H3.5C3.63261 10.5 3.75979 10.5527 3.85355 10.6464C3.94732 10.7402 4 10.8674 4 11V13Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18.498H1.5C1.22386 18.498 1 18.7218 1 18.998V20.998C1 21.2741 1.22386 21.498 1.5 21.498H3.5C3.77614 21.498 4 21.2741 4 20.998V18.998C4 18.7218 3.77614 18.498 3.5 18.498Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.5H1.5C1.10218 17.5 0.720644 17.658 0.43934 17.9393C0.158035 18.2206 0 18.6022 0 19L0 21C0 21.3978 0.158035 21.7794 0.43934 22.0607C0.720644 22.342 1.10218 22.5 1.5 22.5H3.5C3.89782 22.5 4.27936 22.342 4.56066 22.0607C4.84196 21.7794 5 21.3978 5 21V19C5 18.6022 4.84196 18.2206 4.56066 17.9393C4.27936 17.658 3.89782 17.5 3.5 17.5ZM4 21C4 21.1326 3.94732 21.2598 3.85355 21.3536C3.75979 21.4473 3.63261 21.5 3.5 21.5H1.5C1.36739 21.5 1.24021 21.4473 1.14645 21.3536C1.05268 21.2598 1 21.1326 1 21V19C1 18.8674 1.05268 18.7402 1.14645 18.6464C1.24021 18.5527 1.36739 18.5 1.5 18.5H3.5C3.63261 18.5 3.75979 18.5527 3.85355 18.6464C3.94732 18.7402 4 18.8674 4 19V21Z",
    stroke: "none",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9857_122346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBold);
export default __webpack_public_path__ + "static/media/list-bold.e239ef6fa5143e19d129312a4ccfeac0.svg";
export { ForwardRef as ReactComponent };